// src/jira/sprint/types.ts
var JiraSprintAriResourceOwner = "jira", JiraSprintAriResourceType = "sprint";

export {
  JiraSprintAriResourceOwner,
  JiraSprintAriResourceType
};
